import { useGetKioskTerminalsQuery, GqlGetKioskTerminalsQuery } from 'types/graphql';

const defaultPollInterval = 15 * 1000; // 15 seconds
const fallbackArray = [];

export default function useKioskTerminals(dispensary): GqlGetKioskTerminalsQuery['getKioskTerminals'] {
  const directedOrders = dispensary?.orderTypesConfigV2?.kiosk?.directedOrders;

  const { data } = useGetKioskTerminalsQuery({
    fetchPolicy: 'network-only',
    pollInterval: defaultPollInterval,
    skip: !directedOrders,
    variables: { dispensaryId: dispensary?.id },
  });

  return data?.getKioskTerminals ?? fallbackArray;
}
